// Sentry initialization (must be first)
import './sentry-init'

// Dependencies
import { _ } from './utils'
import { makeGtmCall, beginCheckoutTracking, productTracking, cartViewTracking, productViewTracking, forumViewTracking, purchaseTracking, checkoutTracking, loginTracking, registrationTracking, forumPostTracking, categoryViewTracking, checkConversion, globalPageViewTracking } from './tracking'
import svg4everybody from 'svg4everybody'
import Accordion from './modules/accordion'
import Bell from './modules/bell'
import burger from './modules/burger'
import Cart from './modules/cart'
import CheckPostcodeRequired from './modules/check-post-code-required'
import CheckRequired from './modules/check-required'
import CheckboxToggle from './modules/checkbox-toggle'
import CheckedToggle from './modules/checked-toggle'
import CloseMessage from './modules/close-message'
import CloseWindow from './modules/close-window'
import ColorCheck from './modules/color-check'
import CountProducts from './modules/count-products'
import EntranceTransition from './modules/entrance-transitions'
import FormPost from './modules/form-post'
import FormValidate from './modules/form-validate'
import ForumMove from './modules/forum-move'
import Heart from './modules/heart'
import InputReveal from './modules/input-reveal'
import LazyLoad from './modules/lazy-load'
import Listing from './modules/listing'
import Map from './modules/map'
import MatchHeight from './modules/match-height'
import Modal from './modules/modal'
import NoHashModal from './modules/no-hash-modal'
import objectFit from './modules/object-fit'
import PasswordReveal from './modules/password-reveal'
import Range from './modules/range'
import RangeSeasons from './modules/range-seasons'
import RevealButton from './modules/reveal-button'
import RevealCheckbox from './modules/reveal-checkbox'
import SelectUrl from './modules/select-url'
import smoothScroll from './modules/smooth-scroll'
import Sticky from './modules/sticky'
import Stockist from './modules/stockist'
import Tabs from './modules/tabs'
import TinySlider from './modules/tiny-slider'
import toggleClass from './modules/toggle-class'
import toggleLoading from './modules/toggle-loading'
import Tooltip from './modules/tooltip'
import TriggerCheckRequired from './modules/trigger-check-required'
import Video from './modules/video'
import ZoomImage from './modules/zoom-image'
import ImageTextVideo from './modules/image-text-video'
import imageUpload from './modules/image-upload'
import offer from './modules/offer-calendar'
import Countdown from './modules/countdown'
import Autosuggestion from './modules/autosuggestion'
import ClearInput from './modules/clear-input'
import { NumberControl } from './modules/number-control'
import ProductBlockLoader from '@/javascript/modules/product-blocks-loader'
// doc events
import Menu from './modules/menu'
import SiteSearch from './modules/site-search'
import SearchModal from './modules/search-modal'
import { CharityBox } from './modules/charity-box'
import { RewardsPoints } from './modules/rewards-points'
import StockAlertToggle from './modules/stock-alert-toggle'

window.dataLayer = window.dataLayer || []

const siteSearchEl = _('site-search', 'element').node()

if (siteSearchEl) {
    new SiteSearch(siteSearchEl)
}

new Menu()
new CloseWindow()
checkConversion()
// new PushNotifications()
productTracking(_('product', 'element').nodes())
forumPostTracking(_('forum-post-tracking', 'element').nodes())
beginCheckoutTracking(_('begin-checkout-tracking', 'element').nodes())
globalPageViewTracking()

_('new-choice', 'element')
    .nodes()
    .map((el) => new TriggerCheckRequired(el))
_('old-choice', 'element')
    .nodes()
    .map((el) => new TriggerCheckRequired(el))
_('', 'entrance')
    .nodes()
    .map((el) => new EntranceTransition(el))
_('', 'required')
    .nodes()
    .map((el) => new CheckRequired(el))
_('', 'validate')
    .nodes()
    .map((el) => new FormValidate(el))
_('accordion', 'element')
    .nodes()
    .map((el) => new Accordion(el))
_('', 'check-postcode-required')
    .nodes()
    .map((el) => new CheckPostcodeRequired(el))
_('burger')
    .nodes()
    .map((el) => burger(el))
_('bell')
    .nodes()
    .map((el) => new Bell(el))
_('cart', 'element')
    .nodes()
    .map((el) => new Cart(el))
_('checkbox-toggle', 'element')
    .nodes()
    .map((el) => new CheckboxToggle(el))
_('checked-toggle')
    .nodes()
    .map((el) => new CheckedToggle(el))
_('checkout-tracking')
    .nodes()
    .map((el) => checkoutTracking(el))
_('color-check')
    .nodes()
    .map((el) => new ColorCheck(el))
_('live-countdown')
    .nodes()
    .map((el) => new Countdown(el))
_('count-products', 'element')
    .nodes()
    .map((el) => new CountProducts(el))
_('form-post')
    .nodes()
    .map((el) => new FormPost(el))
_('forum-subtopics')
    .nodes()
    .map((el) => new ForumMove(el))
_('heart')
    .nodes()
    .map((el) => new Heart(el))
_('image', 'lazyload')
    .nodes()
    .map((el) => new LazyLoad(el))
_('image-upload')
    .nodes()
    .map((el) => imageUpload(el))
_('input-reveal')
    .nodes()
    .map((el) => new InputReveal(el))
_('listing')
    .nodes()
    .map((el) => new Listing(el))
_('map')
    .nodes()
    .map((el) => new Map(el))
_('match-height')
    .nodes()
    .map((el) => new MatchHeight(el))
_('message', 'element')
    .nodes()
    .map((el) => new CloseMessage(el))
_('modal')
    .nodes()
    .map((el) => new Modal(el))
_('no-hash-modal')
    .nodes()
    .map((el) => new NoHashModal(el))
_('object-fit-contain', 'polyfill')
    .nodes()
    .map((el) => objectFit(el, 'contain'))
_('object-fit-cover', 'polyfill')
    .nodes()
    .map((el) => objectFit(el, 'cover'))
_('offer-cal', 'element')
    .nodes()
    .map((el) => offer(el))
_('password-reveal')
    .nodes()
    .map((el) => new PasswordReveal(el))
_('cart', 'element')
    .nodes()
    .map((el) => cartViewTracking(el))
_('product-view-tracking', 'element')
    .nodes()
    .map((el) => productViewTracking(el))
_('forum-view-tracking')
    .nodes()
    .map((el) => forumViewTracking(el))
_('category-view-tracking', 'element')
    .nodes()
    .map((el) => categoryViewTracking(el))
_('purchase-tracking', 'element')
    .nodes()
    .map((el) => purchaseTracking(el))
_('range')
    .nodes()
    .map((el) => new Range(el))
_('range-seasons')
    .nodes()
    .map((el) => new RangeSeasons(el))
_('reveal-button')
    .nodes()
    .map((el) => new RevealButton(el))
_('reveal-checkbox')
    .nodes()
    .map((el) => new RevealCheckbox(el))
_('select-url')
    .nodes()
    .map((el) => new SelectUrl(el))
_('smooth-scroll')
    .nodes()
    .map((el) => smoothScroll(el))
_('sticky')
    .nodes()
    .map((el) => new Sticky(el))
_('sticky', 'polyfill')
    .nodes()
    .map((el) => new Sticky(el))
_('stockist')
    .nodes()
    .map((el) => new Stockist(el))
_('tab-trigger')
    .nodes()
    .map((el) => new Tabs(el))
_('tiny-slider')
    .nodes()
    .map((el) => new TinySlider(el))
_('toggle-class')
    .nodes()
    .map((el) => toggleClass(el))
_('toggle-loading')
    .nodes()
    .map((el) => toggleLoading(el))
_('zoom-image')
    .nodes()
    .map((el) => new ZoomImage(el))
_('tooltip', 'element')
    .nodes()
    .map((el) => new Tooltip(el))
_('user-login', 'event')
    .nodes()
    .map((el) => loginTracking(el))
_('user-reg', 'event')
    .nodes()
    .map((el) => registrationTracking(el))
_('video', 'element')
    .nodes()
    .map((el) => new Video(el))
_('image-text-video')
    .nodes()
    .map((el) => new ImageTextVideo(el))
_('input-clear-trigger')
    .nodes()
    .map((el) => new ClearInput(el))
_('autosuggestion')
    .nodes()
    .map((el) => new Autosuggestion(el))

const siteSearchModal = document.querySelector('[data-element="site-search"].site-search')

if (siteSearchModal) {
    new SearchModal(siteSearchModal)
}

_('gtm-click')
    .nodes()
    .map((el) => {
        el.dataset.enabled = el.dataset.enabled || 'false'
        if (el.dataset.enabled === 'true') {
            return false
        }
        el.dataset.enabled = 'true'
        el.addEventListener('click', () => {
            makeGtmCall(el)
        })
    })

_('gtm-call')
    .nodes()
    .map((el) => makeGtmCall(el))

_('number-control')
    .nodes()
    .map((el) => {
        new NumberControl(el)
    })
_('charity-box')
    .nodes()
    .map((el) => {
        new CharityBox(el)
    })
_('rewards')
    .nodes()
    .map((el) => {
        new RewardsPoints(el)
    })
_('stock-alert-toggle', 'element')
    .nodes()
    .map((el) => {
        new StockAlertToggle(el)
    })
// External SVG Polyfill
svg4everybody({ nosvg: false })

const bar = document.getElementById('bar')

if (bar) {
    const barHtml = bar.innerHTML

    window.addEventListener(
        'resize',
        function () {
            bar.innerHTML = ''
            bar.innerHTML = barHtml
        },
        true
    )
}

new ProductBlockLoader()
